module.exports = __webpack_public_path__ + "static/NeuzeitSLTStd-BookHeavy-4123633d8273a9689d13fb2f56cce11b.ttf";